import React from "react";
import { IClassScheduleCardProps } from "./class-schedule-card.types";
import {
  ClassScheduleContainer,
  ClassScheduleSubjectBlock,
  ClassScheduleRow,
  ClassScheduleIconWrapper,
  PlaceholderIconWrapper,
  ClassScheduleIcon,
  ClassScheduleSubject,
  ClassScheduleTime,
  ClassScheduleHeading
} from "./class-schedule-card.styles";

const ClassScheduleCard: React.FC<IClassScheduleCardProps> = ({ schedule }) => {
  return (
    <ClassScheduleContainer isWidthApplied={true}>
      <ClassScheduleHeading>{schedule.day}</ClassScheduleHeading>
      {schedule.session.map((subject, index) => (
        <ClassScheduleSubjectBlock key={index}>
          <ClassScheduleRow>
            <ClassScheduleIconWrapper bgColor={subject.background_colour}>
              <ClassScheduleIcon
                src={subject.icon}
                alt={`${subject.icon} icon`}
              />
            </ClassScheduleIconWrapper>
            <ClassScheduleSubject textColor={subject.text_color}>
              {subject.subject}
            </ClassScheduleSubject>
          </ClassScheduleRow>

          <ClassScheduleRow>
            <PlaceholderIconWrapper />
            <ClassScheduleTime>{subject.time}</ClassScheduleTime>
          </ClassScheduleRow>
        </ClassScheduleSubjectBlock>
      ))}
    </ClassScheduleContainer>
  );
};

export { ClassScheduleCard };
